import { shareReplay } from 'rxjs/operators';

// Using plain old shareReplay(1) results in queries not being released
// and other sadness. This is the way forward when you need that kind of
// functionality but without the pain.
export function safeReplay<T>() {
  return shareReplay<T>({ bufferSize: 1, refCount: true });
}
